import React from 'react'
import DraggableList from './Viewpager'
import Notes from '../assets/img/notes.png';

function SkillSet() {
    const arraySkills = [['Front End','React, Redux, Next.js'],
                        ['Back End','Node, Express, Firebase, Prisma'],
                        ['App Dev','React Native'],
                        ['Languages','Java, JavaScript, TypeScript'],
                        ['Others','MongoDB, Tailwind CSS & much more...']
                    ]   
    return (
        <div id="skills" className="skillSet">
            <div className="draggableItems">
                <h1>Variable Skill Set <strong style={{color:"orange"}}>.</strong></h1>
                <div className="SkillSetItems" style={{display:"flex",justifyContent:"space-between",alignItems: "center",width:"120%"}}>
                    <DraggableList items={arraySkills}/>
                </div>
            </div>
                <div className="notesDiv" style={{width:"50%",marginTop:100}}>
                <img className="notes" src={Notes} alt="Notes" width="100%"/>
                <p className="cartoonText" style={{fontSize:"150%",color:"orange",textAlign:"center"}}>PS. My Skill set is Literally Variable, Try Dragging and Rearranging one of the Skills :p</p>
                </div>
        </div>
    )
}

export default SkillSet
